import React from 'react';

import useIntakeBlockToggle, { intakeBlocksEnum } from '../../../../hooks/useIntakeBlockToggle';
import { useIntakeCareLocation } from '../../../../hooks/useIntakeCareLocation';
import { DischargeField } from './DischargeField';
import LocationField from './LocationField';
import { PayorField } from './PayorField';
import TypeOfCareField from './TypeOfCareField';

export default function TypeOfCareBlock() {
  const { isOn } = useIntakeBlockToggle();
  const { isCareLocationEnabled } = useIntakeCareLocation();

  if (!isOn(intakeBlocksEnum.typeofcare)) {
    return null;
  }

  return (
    <>
      <DischargeField />
      <TypeOfCareField />
      <PayorField />
      {isCareLocationEnabled && <LocationField />}
    </>
  );
}
